/** Les formats que l'écran répète partout, écrits une fois. */

const DATE = new Intl.DateTimeFormat("fr-FR", {
  day: "2-digit", month: "2-digit", year: "numeric",
  hour: "2-digit", minute: "2-digit",
});

export function quand(iso: string | null | undefined): string {
  if (!iso) return "—";
  const instant = new Date(iso);
  return Number.isNaN(instant.getTime()) ? "—" : DATE.format(instant);
}

/**
 * Une taille de fichier, en unités que le métier emploie.
 *
 * Base 1024 et non 1000 : c'est ce que l'explorateur de fichiers du métreur
 * affiche, et donner un autre chiffre que le sien pour le même fichier
 * n'apporterait qu'un doute.
 */
export function poids(octets: number): string {
  if (!octets) return "—";
  const unites = ["o", "Ko", "Mo", "Go"];
  let valeur = octets;
  let rang = 0;
  while (valeur >= 1024 && rang < unites.length - 1) {
    valeur /= 1024;
    rang += 1;
  }
  return `${valeur.toFixed(rang === 0 ? 0 : 1).replace(".", ",")} ${unites[rang]}`;
}

/** Les initiales d'un nom, pour la pastille. */
export function initiales(nom: string | undefined | null): string {
  const mots = (nom || "").trim().split(/\s+/).filter(Boolean);
  if (!mots.length) return "?";
  return mots.slice(0, 2).map((m) => m[0]!.toUpperCase()).join("");
}
